import { render, staticRenderFns } from "./DetailKegiatan.vue?vue&type=template&id=6ace7bc0&"
import script from "./DetailKegiatan.vue?vue&type=script&lang=js&"
export * from "./DetailKegiatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports